<template>
  <empty-component text="暂无入驻记录"></empty-component>
</template>

<script>
import EmptyComponent from './EmptyComponent.vue'

export default {
  name: 'JoinRecord',
  components: {
    EmptyComponent
  }
}
</script>
